<script setup lang="ts">
import { EntityRatingTargetItem, type IRatingTarget } from '~/components/entity/rating-target'
import { Label } from '~/components/ui/label'

const props = defineProps<{
  label: string
  /** Chosen item, rendered as its card once the step is answered */
  selectedItem?: IRatingTarget | null
}>()

const emit = defineEmits<{
  change: []
}>()

const isAnswered = computed(() => !!props.selectedItem)
</script>

<template>
  <div v-if="isAnswered" class="space-y-2">
    <Label>{{ props.label }}</Label>
    <EntityRatingTargetItem
      :item="props.selectedItem!"
      :edit-label="$t('feature.reviews_add_form.step.change')"
      selected
      readonly
      @edit="emit('change')"
    />
  </div>

  <div v-else class="space-y-3">
    <Label>{{ props.label }}</Label>
    <slot />
  </div>
</template>
